import { database, storage } from "../../config/firebase";

export const getViajes = () => dispatch => {
  dispatch({ type: "LOADING_VIAJES" });
  database.ref("viajes").on("value", snpashot => {
    dispatch({ type: "FETCHED_VIAJES", payload: snpashot.val() || {} });
  });
};

export const postViaje = values => dispatch => {
  const viajeKey = database
    .ref("viajes")
    .push({ ...values })
    .getKey();

  database
    .ref("viajes")
    .child(viajeKey)
    .update({ key: viajeKey })
    .then(res => console.log("done", res));
  dispatch({ type: "ADDED_VIAJE" });
  setTimeout(() => dispatch({ type: "REMOVE_ADDED_VIAJE" }), 2000);
};

export const editViaje = values => dispatch => {
  database
    .ref("viajes")
    .child(values.key)
    .update({ ...values })
    .then(x => console.log("Updated"));
  dispatch({ type: "ADDED_VIAJE" });
  setTimeout(() => dispatch({ type: "REMOVE_EDITED_VIAJE" }), 2000);
};

export const uploadSetImages = ({ ...vals }) => () => {
  const item = { ...vals.values };
  const setImagesKey = database
    .ref("actividadesPreguntas")
    .push({ ...item, imageSet: { imageSetLink: "" } })
    .getKey();

  database
    .ref("actividadesPreguntas")
    .child(setImagesKey)
    .update({ key: setImagesKey });

  const storageRef = storage.ref("actividadesPreguntas");

  vals.values.imageSet.forEach((attachment, i) => {
    const uploadTask = storageRef
      .child(`${setImagesKey}/${attachment.name}`)
      .put(vals.values.imageSet[i]);

    uploadTask.on(
      "state_changed",
      function(snapshot) {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is${progress}% done`);
      },
      function(error) {
        console.log(error);
      },
      function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          database
            .ref("creatorActividades")
            .child(setImagesKey)
            .child("imageSet")
            .push({ imageSetLink: downloadURL });
        });
      }
    );
  });
};

export const deleteViaje = id => dispatch => {
  database
    .ref("viajes")
    .child(id)
    .remove()
    .then(x => console.log("Removed", x));

  dispatch({ type: "DELETED_VIAJE" });
  setTimeout(() => dispatch({ type: "REMOVE_DELETED_VIAJE" }), 2000);
};
